import { useSelectedInputField } from "@/features/sparxsEditor/hooks/editor/useSelectedInputField";

export type UseSectionFormSelectionOptions = {
  /** When true, selection requires a non-empty `formLabel` (e.g. table sections). */
  requireNonemptyFormLabel?: boolean;
};

export const useSectionFormSelection = (
  formLabel: string,
  options?: UseSectionFormSelectionOptions,
) => {
  const selectedField = useSelectedInputField();
  const isSelected =
    options?.requireNonemptyFormLabel === true
      ? formLabel.length > 0 && selectedField === formLabel
      : selectedField === formLabel;
  return { selectedField, isSelected };
};
